import React, { useMemo } from "react";
import calender from "../Assets/Images/calender.png";
import sell from "../Assets/Images/sell.png";
import { formatAmount } from "../utils/formatAmount";
import { timeformatter } from "../utils/dateformatter";

const InvestmentDetailDates = ({ state, type }) => {
  const break_down = state?.break_down
    ? state?.break_down[state?.break_down?.length - 1]
    : null;

  const opportunity = state?.investment;

  const amount = state?.amount;
  const _currency =
    state?.__currency === "NGR" ||
    state?.investment?.currency === "NGR" ||
    state?.cycle_details?.currency === "NGR"
      ? "₦"
      : "$";
  const _roi = opportunity?.roi || state?.cycle_details?.roi;

  const ExpectedRio = useMemo(() => {
    const ROI = Number(_roi) / 100;
    const ROIAmount = ROI * amount;

    return amount && _roi ? ROIAmount : null;
  }, [amount, _roi]);

  const tenure = state?.investment?.duration || state?.cycle_details?.duration;

  const payouts = state?.cycle_details?.paymentSchedules?.expected_date
    ? state?.cycle_details?.paymentSchedules?.expected_date
    : state?.investment?.paymentSchedules?.expected_date;
  const maturityDate = payouts ? payouts[payouts?.length - 1]?.date : null;
  const details =
    type === "REAL-ESTATE"
      ? state?.investment?.property_investment_type?.toLocaleLowerCase() ===
          "mudarabah" ||
        state?.investment?.property?.property_investment_type?.toLocaleLowerCase() ===
          "mudarabah"
        ? [
            {
              icon: calender,
              label: "Tenure ",
              value: state?.investment?.property?.property_appreciation
                ? `${state?.investment?.property?.property_appreciation} year${
                    Number(
                      state?.investment?.property?.property_appreciation,
                    ) === 1
                      ? ""
                      : "s"
                  }`
                : `${state?.investment?.property_appreciation} year${
                    Number(state?.investment?.property_appreciation) === 1
                      ? ""
                      : "s"
                  }`,
            },
            // {
            //   icon: sell,
            //   label: "Maturity date",
            //   value: "-",
            // },
          ]
        : [
            {
              icon: calender,
              label: "Tenure ",
              value: state?.investment?.property?.property_appreciation
                ? `${state?.investment?.property?.property_appreciation} year${
                    Number(
                      state?.investment?.property?.property_appreciation,
                    ) === 1
                      ? ""
                      : "s"
                  }`
                : `${state?.investment?.property_appreciation} year${
                    Number(state?.investment?.property_appreciation) === 1
                      ? ""
                      : "s"
                  }`,
            },
            // {
            //   icon: sell,
            //   label: "Maturity date",
            //   value: "-",
            // },
            {
              icon: sell,
              label: "Expected Annual Income",
              value: ExpectedRio
                ? `${_currency}${formatAmount(ExpectedRio + +amount)}`
                : state?.investment?.annual_roi
                  ? `${_currency}${formatAmount(
                      (state?.investment?.annual_roi *
                        state?.investment?.amount_per_unit *
                        state?.amount) /
                        100,
                    )}`
                  : state?.investment?.property?.annual_roi
                    ? `${_currency}${formatAmount(
                        (state?.investment?.property?.annual_roi *
                          state?.investment?.amount) /
                          100,
                      )}`
                    : `-`,
            },
            // {
            //   icon: sell,
            //   label: "Upcoming Exit Window",
            //   value: `-`,
            // },
          ]
      : state?.investment?.investment_type?.toLocaleLowerCase() ===
            "mudarabah" ||
          state?.cycle_details?.investment_type?.toLocaleLowerCase() ===
            "mudarabah"
        ? [
            {
              icon: calender,
              label: "Tenure ",
              value: !tenure
                ? ""
                : tenure?.includes("week") || tenure?.includes("Month")
                  ? tenure
                  : `${tenure} month${Number(tenure) === 1 ? "" : "s"}`,
            },
            {
              icon: sell,
              label: "Maturity Date",
              value: maturityDate
                ? timeformatter(maturityDate, "formal", false, true)
                : "Not Started",

              noteColor: "#6935D3",
            },
          ]
        : [
            {
              icon: calender,
              label: "Tenure ",
              value: !tenure
                ? ""
                : tenure?.includes("week") || tenure?.includes("Month")
                  ? tenure
                  : `${tenure} month${Number(tenure) === 1 ? "" : "s"}`,
            },
            {
              icon: sell,
              label: "Maturity Date",
              value: maturityDate
                ? timeformatter(maturityDate, "formal", false, true)
                : "Not Started",

              noteColor: "#6935D3",
            },
            {
              icon: sell,
              label: "Expected Payout ",
              value:
                break_down &&
                state?.investment_category?.name?.toLocaleLowerCase() ==
                  "exchange traded commodities" &&
                break_down?.investment_loss < 0
                  ? `${_currency}${formatAmount(break_down?.new_amount)}`
                  : ExpectedRio
                    ? `${_currency}${formatAmount(ExpectedRio + +amount)}`
                    : `-`,
            },
          ];

  return (
    <div className=" md:p-5 w-full">
      <div className=" text-[16px]  font-[500] mb-3 text-[#131e3d] ">
        Investment Detail
      </div>
      <div className="mb-5 rounded-[12px] border border-[#f0f0f5]  w-full max-w-[698px] p-4 bg-white">
        {details.map((detail, index) => (
          <React.Fragment key={index}>
            <div className="flex justify-between items-center py-4">
              <div className="flex gap-2 items-center">
                <img src={detail.icon} alt={detail.label} className="w-5 h-5" />
                <div className="text-[] font-[400] text-[#9C9C9E]">
                  {detail.label}
                </div>
              </div>
              <div className="text-[] font-[500] text-[#131E3D]">
                {detail.value}
                {detail.note && (
                  <span className="text-[#6935D3]"> {detail.note}</span>
                )}
              </div>
            </div>
            {index < details.length - 1 && (
              <div className="w-full h-px bg-[#F2F2F7]"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default InvestmentDetailDates;
